import { z } from "zod";
import {
  DateSchema,
  EmailSchema,
  IdSchema,
  IsActiveSchema,
  NameSchema,
  PhoneSchema,
  UserRoleSchema,
} from "./commonSchema";

export const UserSchema = z.object({
  id: IdSchema,
  email: EmailSchema,
  name: NameSchema,
  phone: PhoneSchema.nullish(),
  role: UserRoleSchema,
  workshopId: IdSchema,
  isActive: IsActiveSchema,
  createdBy: IdSchema.nullish(),
  createdAt: DateSchema,
  createdByName: NameSchema.nullish(),
  updatedAt: DateSchema,
  deletedAt: DateSchema.nullish(),
  deletedBy: IdSchema.nullish(),
  deletedByName: NameSchema.nullish(),
});

export type User = z.infer<typeof UserSchema>;

export const UserListItemSchema = UserSchema.pick({
  id: true,
  email: true,
  name: true,
  role: true,
  phone: true,
  isActive: true,
  createdAt: true,
  deletedAt: true,
  createdByName: true,
});

export type UserListItem = z.infer<typeof UserListItemSchema>;

export const CreateUserSchema = UserSchema.pick({
  email: true,
  name: true,
  phone: true,
  role: true,
  isActive: true,
});

export type CreateUser = z.infer<typeof CreateUserSchema>;
